import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import Admin from 'pages/administrator'
import ListEmail from 'pages/list-email'
import ListEmailV2 from 'pages/list-email-v2'
import TransactionHistory from 'pages/transaction-history'
import User from 'pages/user'
import UpdatePassword from 'pages/user-information/update-password'
import UserMeyReal from 'pages/user-mey-real'
import { PAGES } from 'routes/index'

export const userRoutes: RouteObject[] = [
  {
    path: PAGES.USER,
    element: (
      <PrivateRoute feature={FEATURE.USER_MEY_FI}>
        <User />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.USER_MEY_REAL,
    element: (
      <PrivateRoute feature={FEATURE.USER_MEY_REAL}>
        <UserMeyReal />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.TRANSACTION_HISTORY,
    element: (
      <PrivateRoute feature={FEATURE.TRANSACTION_HISTORY}>
        <TransactionHistory />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.USER_ADMIN,
    element: (
      <PrivateRoute feature={FEATURE.ADMIN_MANAGEMENT}>
        <Admin />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.UPDATE_PASSWORD,
    element: (
      <PrivateRoute feature={FEATURE.DASHBOARD}>
        <UpdatePassword />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.EMAIL,
    element: (
      <PrivateRoute feature={FEATURE.EMAIL}>
        <ListEmail />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.EMAIL_V2,
    element: (
      <PrivateRoute feature={FEATURE.EMAIL}>
        <ListEmailV2 />
      </PrivateRoute>
    ),
  },
]
